import { createRoot } from "react-dom/client";
import "../../ui/kit/styles.ts";
import type { InputRouter } from "../../ui/input/router.ts";
import { ReadingView, type ReadingControl } from "./panel.tsx";

/**
 * Mounts the reading panel (P1.9-T37) in its host in the overlay root, a React root of its own that follows the
 * reading store. The host comes after the HUD's and before the loading shell's and the game menu's, so the shell and
 * the menu cover the panel; the page keeps the host inert until the world is revealed.
 *
 * @param host The page's `#reading` element.
 * @param store The store the panel reads and closes.
 * @param input The page's input router, which the panel opens its layer on.
 * @example
 * mountReading(document.getElementById("reading") as HTMLElement, reading, input);
 */
export function mountReading(host: HTMLElement, store: ReadingControl, input: Pick<InputRouter, "open" | "owner">): void {
  createRoot(host).render(<ReadingView store={store} input={input} />);
}
